
import React from 'react';
import { motion } from 'framer-motion';

interface SkillProps {
  name: string;
  delay: number;
}

const SkillItem: React.FC<SkillProps> = ({ name, delay }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: delay * 0.1 }}
      viewport={{ once: true }}
      className="flex items-center justify-center bg-gray-800 rounded-lg p-4 shadow-md hover:bg-gray-700 hover:shadow-lg hover:shadow-yellow-300/10 transition duration-300 border border-transparent hover:border-yellow-300/30"
    >
      <p className="text-gray-300 font-semibold">{name}</p>
    </motion.div>
  );
};

interface SkillGroupProps {
  title: string;
  skills: string[];
  delay: number;
}

const SkillGroup: React.FC<SkillGroupProps> = ({ title, skills, delay }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: delay * 0.2 }}
      viewport={{ once: true }}
    >
      <h3 className="text-xl font-semibold text-yellow-300 mb-4">{title}</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {skills.map((skill, index) => (
          <SkillItem key={index} name={skill} delay={index} />
        ))}
      </div>
    </motion.div>
  );
};

const SkillsSection: React.FC = () => {
  const technicalSkills = ["Python", "Java", "PHP", "HTML & CSS", "SQL"];
  const tools = ["Git", "MySQL", "Apache 2", "Adobe Photoshop/Illustrator", "Cisco Packet Tracer"];
  const softSkills = ["Problem-Solving", "Project Management", "Data Visualization", "Statistical Analysis", "Event Management"];

  return (
    <div id="skills" className="bg-black bg-opacity-80 p-8 rounded-lg shadow-lg">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-2xl font-bold text-yellow-300 mb-6"
      >
        Skills
      </motion.h2>
      
      <div className="space-y-8">
        <SkillGroup title="Technical Skills" skills={technicalSkills} delay={0} />
        <SkillGroup title="Tools" skills={tools} delay={1} />
        <SkillGroup title="Soft Skills" skills={softSkills} delay={2} />
      </div>
    </div>
  );
};

export default SkillsSection;
